import { HelichrysumIcon } from "@/components/brand/HelichrysumIcon";

export const RotatingBadge = ({ className = "h-32 w-32" }) => (
  <div className={`relative grid place-items-center rounded-full bg-navy text-ivory shadow-[0_20px_50px_-15px_rgba(15,30,51,0.6)] ${className}`} data-testid="hero-rotating-badge">
    <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full animate-spin-slow" aria-hidden="true">
      <defs>
        <path id="pf-badge-circle" d="M100,100 m-76,0 a76,76 0 1,1 152,0 a76,76 0 1,1 -152,0" />
      </defs>
      <text fontFamily="Jost, sans-serif" fontSize="12.5" letterSpacing="2.6" fill="#F6F0E6">
        <textPath href="#pf-badge-circle">CON POSTBIOTICI DELL'ELICRISO · SILVER AGE · </textPath>
      </text>
    </svg>
    <span className="sr-only">Con postbiotici dell'elicriso</span>
    <HelichrysumIcon className="relative h-1/3 w-1/3 text-gold" />
  </div>
);
